<template>
  <div >
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-container fluid>

      <b-row>
        <b-col class="subtitulos">
          Generación de reporte de Ptis presentados
        </b-col>
      </b-row>
      <div class="mt-2 col-md-12"></div>
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(buscar)">
          <b-row  v-if="$localStorageService.can('Rep_UP_M2_fechas')">
            <b-col>
              <b-row>
                <b-col cols="4">
                  <validation-provider name="fcInicioVal" :rules="{ required: true }" v-slot="validationContext">
                    <label>Fecha inicio:<validacion/></label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-datepicker placeholder="Fecha inicio"
                                         :max="new Date()"
                                         @input="fechaMaxima($event)"
                      ></b-form-datepicker>
                    </b-input-group>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>

                <b-col cols="4">
                  <validation-provider name="fcFinVal" :rules="{ required: true }" v-slot="validationContext">
                    <label>Fecha fin:<validacion/></label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-datepicker placeholder="Fecha fin"
                                         v-model="filtro.fechaFin"
                                         :max="max()"
                                         :min="filtro.fechaInicio"
                      ></b-form-datepicker>
                    </b-input-group>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>
<!--                <b-col cols="4">
                  <b-form-group size="sm" class="mb-2">
                    <label>Tipo Reporte:<validacion/></label>
                    <b-form-select v-model="filtro.tipoBusqueda" :options="options" size="sm"></b-form-select>
                  </b-form-group>
                </b-col>-->

              </b-row>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>

      <div class="row">
        <div class="col-10" >
          <b-form-group v-if="$localStorageService.can('Rep_UP_M2_clinicas')" align="left">
            <label>Clínicas</label>
            <v-select
                style="width: 100%"
                name="clinica"
                placeholder="--Seleccionar--"
                label="nombreClinica"
                multiple
                :reduce="(variable) => variable.idClinica"
                :options="listaClinicas"
                v-model="filtro.clinica"
            ><span slot="no-options">No hay clínicas disponibles</span>
            </v-select>
          </b-form-group>
          <b-form-invalid-feedback :state="filtro.clinica != null && filtro.clinica.length > 0 ">
            Este campo es obligatorio
          </b-form-invalid-feedback>
        </div>
        <div v-if="$localStorageService.can('Rep_UP_M2_cli_todas')" class="col-2 mt-4" >
          <b-button
              v-if="todas"
              class="btnn"
              variant="outline-primary"
              v-b-tooltip.hover
              @click="todos()"
          >
            <b-icon icon="check2-all"></b-icon>
            <span class="labels">Seleccionar Todas</span>
          </b-button>
          <b-button
              v-else
              class="btnn"
              variant="outline-primary"
              v-b-tooltip.hover
              @click="clear()"
          >
            <b-icon icon="x"></b-icon>
            <span class="labels">Quitar todas</span>
          </b-button>
        </div>
      </div>

      <b-row>
        <b-col>
          <b-row align-v="center" align-h="center">
            <b-button v-if="$localStorageService.can('Rep_UP_M2_generar')" v-b-tooltip.hover title="Generar reporte" variant="outline-success"
                      @click="generar()" :disabled="loader">Generar
            </b-button>

            <download-excel
                v-if="datosTabla.length > 0 && $localStorageService.can('Rep_UP_M2_excel')"
                :data="datosTabla"
                class="btn btn-primary"
                :fields="fieldsExcel"

                worksheet="My Worksheet"
                name="Ptis presentados.xls"
            >
              Generar Excel
            </download-excel>

          </b-row>
        </b-col>
      </b-row>
      <div class="mt-2 col-md-12"></div>


      <b-row>
        <b-col cols="12">
          <b-table
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="$registrosPorPaginaTabla"
              :current-page="paginaActual"
              responsive
              class="parrafos">

            <template v-slot:cell(fechaInicio)="row">
               <span v-if="row.item.fechaInicio !== null">
                  {{ row.item.fechaInicio}}
                </span>
              <span v-else>
                  Sin Fecha
               </span>
            </template>
            <template v-slot:cell(horaInicio)="row">
               <span v-if="row.item.horaInicio !== null">
                  {{ row.item.horaInicio}}
                </span>
              <span v-else>
                  Sin Hora
               </span>
            </template>
              <template v-slot:cell(fechaFin)="row">
               <span v-if="row.item.fechaFin !== null">
                  {{ row.item.fechaFin}}
                </span>
                <span v-else>
                  Sin Fecha
               </span>
            </template>
            <template v-slot:cell(horaFin)="row">
               <span v-if="row.item.horaFin !== null">
                  {{ row.item.horaFin}}
                </span>
              <span v-else>
                  Sin Hora
               </span>
            </template>

          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla!==undefined && datosTabla.length === 0" variant="warning" show>No hay datos
            </b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="$registrosPorPaginaTabla"
                aria-controls="tabla"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>

import {required} from "vuelidate/lib/validators";

export default {
  name: "reportePtiPresentados",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    diasMaximoMes: null,
    datosTabla: [],
    fields: [],
    paginaActual: 1,
    loader: false,
    listaClinicas: [],
    todas: true,
    filtro: {
      fechaInicio: null,
      fechaFin: null,
      tipoBusqueda: '0',
      clinica: [],
    },
    fieldsExcel: {
      "Clinica": "clinica",
      "EE/Unidad de presentación": "embajador",
      "Puesto (EE, OG, CC)": "grupo",
      "Id Pti": "idPti",
      "Nombre Px": "nombrePaciente",
      "Id de PX": "idPaciente",
      "Ciclo": "ciclo",
      "Categoría": "categoria",
      "Tag": "tag",
      "Fecha Inicio Presentación": "fechaInicio",
      "Hora Inicio Presentación": "horaInicio",
      "Fecha Fin Presentación": "fechaFin",
      "Hora Fin Presentación": "horaFin",
      "Estatus Presentación": "descripcion",
      "Opción presentada": "opcionPresentada",
      "Fase Presentada": "fasePresentada",

    },
    /*
    options: [
      { value: '1', text: 'PTI COBRADO CON TXS'},
      { value: '0', text: 'PTI COBRADO'}
    ]
     */
  }),
  validations: {
    filtro: {
      fechaInicio: {required},
      fechaFin: {required},
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.llenarClinicas();
  },
  methods: {
    max(){
      let dia = new Date(this.filtro.fechaInicio)
      return dia.addDays(this.diasMaximoMes) > new Date() ? new Date(): dia.addDays(this.diasMaximoMes)
    },
    todos() {
      this.todas = false;
      this.listaClinicas.forEach(element => {
        this.filtro.clinica.push(element.idClinica);
      });
    },
    llenarClinicas() {
      this.listaClinicas = this.$localStorageService.getClinicas();
    },
    clear() {
      this.todas = true;
      this.filtro.clinica = [];
      this.loading=false;
    },
    fechaMaxima(event){
      this.diasMaximoMes = this.$moment(event).daysInMonth();
      this.filtro.fechaInicio = event;
      this.filtro.fechaFin = null;

    },
    dateDisabled(ymd, date) {
      const weekday = date.getDay();
      return weekday >= 1 && weekday <= 5;
      /* const weekday = date.getDay()
       const day = date.getDate()
       return weekday === 0 || weekday === 6 || day === 13*/
    },
    generar() {
      this.loader = true;
      this.datosTabla = [];
      this.fields = [];

      const i = new Date(this.filtro.fechaInicio).addDays(1);
      i.setHours(0, 0, 0, 0);
      const inicio = this.$moment(i).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      const f = new Date(this.filtro.fechaFin).addDays(1);
      f.setHours(23, 59, 59, 999);
      const fin = this.$moment(f).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      let filtro = {
        fechaFin: fin,
        fechaInicio: inicio,
        clinica: this.filtro.clinica,
      }
      if (filtro.clinica.length == 0){
        this.$swal({
          icon: "info",
          text: "Debes seleccionar al menos una clínica",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
        this.loader = false;
        return;
      }

      this.$http.post(this.$api + 'reportesV2/ObtenerReportePresentadosV2', filtro).then(respuesta => {
        if (respuesta.data.data) {
          this.fields.push({key: "clinica", label: "Clinica", sortable: true});
          this.fields.push({key: "embajador", label: "EE/Unidad de presentación", sortable: true});
          this.fields.push({key: "grupo", label: "Puesto (EE, OG, CC)", sortable: true});
          this.fields.push({key: "idPti", label: "Id Pti", sortable: true});
          this.fields.push({key: "nombrePaciente", label: "Nombre Px", sortable: true});
          this.fields.push({key: "idPaciente", label: "Id de PX", sortable: true});
          this.fields.push({key: "ciclo", label: "Ciclo", sortable: true});
          this.fields.push({key: "categoria", label: "Categoría", sortable: true});
          this.fields.push({key: "tag", label: "Tag", sortable: true});
          this.fields.push({key: "fechaInicio", label: "Fecha Inicio Presentación", sortable: true});
          this.fields.push({key: "horaInicio", label: "Hora Inicio Presentación", sortable: true});
          this.fields.push({key: "fechaFin", label: "Fecha Fin Presentación", sortable: true});
          this.fields.push({key: "horaFin", label: "Hora Fin Presentación", sortable: true});
          this.fields.push({key: "descripcion", label: "Estatus Presentación", sortable: true});
          this.fields.push({key: "opcionPresentada", label: "Opción presentada", sortable: true});
          this.fields.push({key: "fasePresentada", label: "Fase Presentada", sortable: true});

          /*
          if(this.filtro.tipoBusqueda === "1"){
            this.fields.push({key: "tratamiento", label: "Tratamiento", sortable: true});
            this.fields.push({key: "montoTratamiento", label: "Monto Tratamiento ($)", sortable: true});
          }
           */

          respuesta.data.data.forEach(element => {
            let obj = {
              clinica: element.clinica,
              embajador: element.embajador,
              grupo: element.grupo,
              idPti: element.idPti,
              nombrePaciente: element.nombrePaciente,
              idPaciente: element.idPaciente.toString(),
              ciclo: element.ciclo,
              fechaInicio: element.fechaInicio === null ? null : element.fechaInicio,
              horaInicio: element.horaInicio === null ? null : element.horaInicio,
              fechaFin: element.fechaFin === null ? null : element.fechaFin,
              horaFin: element.horaFin === null ? null : element.horaFin,
              tag: element.tag,
              categoria: element.categoria,
              descripcion: element.descripcion,
              opcionPresentada: element.opcionPresentada,
              fasePresentada: element.fasePresentada,

            }
            this.datosTabla.push(obj)
          })
        }
      }).finally(() => {
        this.loader = false;
        this.paginaActual = 1;
      })
    },
    dato(dato){
      if (dato == null  || dato === ''){
        return '0'
      }
      return dato;
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.filtro[name];
      return $dirty ? !$error : null;
    },
  }
}
</script>

<style scoped>

</style>
